import template from './sw-cms-preview-text-two-column.html.twig';
import './sw-cms-preview-text-two-column.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
